import { render, staticRenderFns } from "./SecaoRecursos.vue?vue&type=template&id=74f68ab2&"
import script from "./SecaoRecursos.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoRecursos.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports